import http from '@/api/http';
import { useUserStore } from '@/stores/counter'
import { setCookie, delCookie } from '@/utils/util.js'


export const login = () => {
    delCookie('code')
    delCookie('x3mf')
    delCookie('userEmail')
    if (
        import.meta.env.VITE_ENV == 'test') {
        window.open('https://teste2api.test.xdf.cn/e2/login?x3id=' +
            import.meta.env.VITE_X3ID + '&state=' + (new Date()).valueOf() + '&returnUrl=' +
            import.meta.env.VITE_BASE_API + '/webnpdp/', '_self')
    } else if (
        import.meta.env.VITE_ENV == 'prod') {
        window.open('https://e2api.staff.xdf.cn/e2/login?x3id=' +
            import.meta.env.VITE_X3ID + '&state=' + (new Date()).valueOf() + '&returnUrl=' +
            import.meta.env.VITE_BASE_API + '/webnpdp/', '_self')
    }
}

export const logout = () => {
    delCookie('code')
    delCookie('x3mf')
    delCookie('userEmail')
    if (
        import.meta.env.VITE_ENV == 'test') {
        window.open('https://teste2api.test.xdf.cn/e2/logout?x3id=' +
            import.meta.env.VITE_X3ID + '&returnUrl=' +
            import.meta.env.VITE_BASE_API + '/webnpdp/login/', '_self')
    } else if (
        import.meta.env.VITE_ENV == 'prod') {
        window.open('https://e2api.staff.xdf.cn/e2/logout?returnUrl=' +
            import.meta.env.VITE_BASE_API + '/webnpdp/login/', '_self')
    }
}

export const getUserRoleInfo = () => {
    const user = useUserStore()
    if (
        import.meta.env.VITE_ENV == 'dev') {
        setTimeout(() => {
            const response = {
                data: {
                    "nickName": "赵越33",
                    "email": "zhaoyue33@xdf.cn",
                    "e2uid": "f15d835e-9f0c-4773-8dcf-f8eb143176e1",
                    "expireTime": "2023-07-03T10:31:37",
                    "x3mf": "18959893bd5442519028915fffa5cb58",
                    "role": "技术",
                    "roleCode": "zbTechnician",
                    "company": "",
                    "rolePermission": {
                        "defaultActive": '0',
                        "menuList": [{
                                name: '市场数据',
                                route: '',
                                icon: 'DataAnalysis',
                                item: [{
                                        name: '市场整体概况',
                                        route: '/market/overallData',
                                    },
                                    {
                                        name: '业务条线数据',
                                        route: '/market/businessData',
                                    },
                                    {
                                        name: '资源渠道数据',
                                        route: '/market/resourceData',
                                    },
                                    {
                                        name: '签约业务类型',
                                        route: '/market/signData',
                                    },
                                    {
                                        name: '渠道细分',
                                        route: '/market/channelData',
                                    }
                                ]
                            },
                            {
                                name: '高校数据',
                                route: '',
                                icon: 'Monitor',
                                item: [{
                                        name: '高校数据',
                                        route: '/highSchool/marketHighSchool',
                                    },
                                    {
                                        name: '官方合作',
                                        route: '/highSchool/marketHighSchoolOfficial',
                                    },
                                    {
                                        name: '高校属性',
                                        route: '/highSchool/attribute',
                                    },
                                    {
                                        name: '高校活动',
                                        route: '/highSchool/activity',
                                    }
                                ]
                            },
                            {
                                name: '网络数据',
                                route: '',
                                icon: 'DataLine',
                                item: [{
                                        name: '整体数据',
                                        route: '/network/overall',
                                    },
                                    {
                                        name: '分公司数据',
                                        route: '/network/company',
                                    },
                                    {
                                        name: '条线数据',
                                        route: '/network/pipeline',
                                    },
                                    {
                                        name: '分公司预算进度',
                                        route: '/network/company-budget',
                                    },
                                    {
                                        name: '签约人群画像',
                                        route: '/network/signCrowd',
                                    }
                                ]
                            },
                            {
                                name: '官网数据',
                                route: '',
                                icon: 'Monitor',
                                item: [{
                                        name: '网站整体数据',
                                        route: '/website/network',
                                    },
                                    {
                                        name: '分公司网站数据',
                                        route: '/website/companyOperate',
                                    },
                                    {
                                        name: '分公司内容发布管理',
                                        route: '/website/companyContent',
                                    },
                                    {
                                        name: '文章收录明细',
                                        route: '/website/article',
                                    },
                                    {
                                        name: '条线专题数据',
                                        route: '/website/line',
                                    }
                                ]
                            },
                            {
                                name: '推广管理',
                                route: '',
                                icon: 'Position',
                                item: [{
                                        name: '媒体账户',
                                        route: '/promotion/medium',
                                    },
                                    {
                                        name: '预算提报',
                                        route: '/promotion/budget',
                                    },
                                    {
                                        name: '费用台账',
                                        route: '/promotion/cost',
                                    },
                                    {
                                        name: '代理管理',
                                        route: '/promotion/agent',
                                    },
                                    {
                                        name: '字段规则',
                                        route: '/promotion/field',
                                    },
                                    {
                                        name: '数据上传',
                                        route: '/promotion/upload',
                                    },
                                    {
                                        name: '分公司邮件接收管理',
                                        route: '/promotion/email',
                                    },
                                    {
                                        name: '关键词管理',
                                        route: '/promotion/keyword',
                                    }
                                ]
                            },
                            {
                                name: '资源管理',
                                route: '',
                                icon: 'FolderOpened',
                                item: [{
                                        name: '表单类型数据',
                                        route: '/resource/formdata',
                                    },
                                    {
                                        name: '毛资源管理',
                                        route: '/resource/clue',
                                    }
                                ]
                            },
                            {
                                name: '运营数据',
                                route: '',
                                icon: 'Monitor',
                                item: [{
                                        name: '小红书账号数据',
                                        route: '/operation/rdAccountData',
                                    },
                                    {
                                        name: '小红书笔记数据',
                                        route: '/operation/rdNoteData',
                                    },
                                    {
                                        name: '门店评价',
                                        route: '/operation/shopEvaluateData',
                                    },
                                    {
                                        name: '抖音/头条数据',
                                        route: '/operation/dyTtData',
                                    },
                                    {
                                        name: '流量洞察',
                                        route: '/operation/trafficInsights',
                                    },
                                    {
                                        name: '门店运营数据',
                                        route: '/operation/mtShop',
                                    }
                                ]
                            },
                            {
                                name: '个人中心',
                                route: '',
                                icon: 'FolderOpened',
                                item: [{
                                        name: '奖品页面',
                                        route: '/wxCenter/prize',
                                    },
                                    {
                                        name: '中奖记录',
                                        route: '/wxCenter/prizeRecord',
                                    }
                                ]
                            },
                            {
                                name: '集采项目',
                                route: '',
                                icon: 'Suitcase',
                                item: [{
                                        name: '实地访学项目名录',
                                        route: '/gaoxiao/accessLearn',
                                    },
                                    {
                                        name: '项目课题管理',
                                        route: '/gaoxiao/projectTopic',
                                    },
                                    {
                                        name: '重点项目',
                                        route: '/gaoxiao/hotProject',
                                    },
                                    {
                                        name: '项目信息管理',
                                        route: '/gaoxiao/projectManage',
                                    },
                                    {
                                        name: '院校信息管理',
                                        route: '/gaoxiao/schoolManage',
                                    },
                                    {
                                        name: '报名信息管理',
                                        route: '/gaoxiao/applicationManage',
                                    }
                                ]
                            },
                            {
                                name: '管理中心',
                                route: '',
                                icon: 'Setting',
                                item: [{
                                        name: '角色管理',
                                        route: '/management/role',
                                    },
                                    {
                                        name: '权限管理',
                                        route: '/management/authority',
                                    },
                                    {
                                        name: '成员管理',
                                        route: '/management/member',
                                    },
                                    {
                                        name: '分公司管理',
                                        route: '/management/company',
                                    },
                                    {
                                        name: '菜单管理',
                                        route: '/management/menulist',
                                    }
                                ]
                            },
                            {
                                name: '全球教育路径',
                                route: '',
                                icon: 'FolderOpened',
                                item: [{
                                    name: '资源',
                                    route: '/education/source',
                                }]
                            },
                            // {
                            //     name: '测试',
                            //     route: '',
                            //     icon: 'Setting',
                            //     item: [{
                            //         name: '测试 ',
                            //         route: '/demo',
                            //     }]
                            // }
                        ],
                        "interfaceList": null
                    },
                    "companyInfoList": null
                }
            }
            user.$patch((state) => {
                state.data = response.data
            })
        }, 1000)
    } else {
        http.post('/npdp/loginCheck/get-user-role-info', {}).then(response => {
            if (response.code == '2001') {
                if (response.data.x3mf != null) {
                    setCookie('x3mf', response.data.x3mf)
                }
                if (response.data.email != null) {
                    setCookie('userEmail', response.data.email)
                }
                user.$patch((state) => {
                    state.data = response.data
                })
            }
        });
    }
}